<svg class="spinner" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
	<circle class="internal-circle" cx="50" cy="50" r="25" />
	<circle class="external-circle" cx="50" cy="50" r="40" />
</svg>
